var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 20.8333H20.8334V25C20.8334 25.4583 20.4584 25.8333 20.0001 25.8333C19.5417 25.8333 19.1667 25.4583 19.1667 25V20.8333H15.0001C14.5417 20.8333 14.1667 20.4583 14.1667 20C14.1667 19.5417 14.5417 19.1667 15.0001 19.1667H19.1667V15C19.1667 14.5417 19.5417 14.1667 20.0001 14.1667C20.4584 14.1667 20.8334 14.5417 20.8334 15V19.1667H25.0001C25.4584 19.1667 25.8334 19.5417 25.8334 20C25.8334 20.4583 25.4584 20.8333 25.0001 20.8333Z",
    fill: "#2B6ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.ee1078ecf880c70cd6e9ab33440a0600.svg";
export { ForwardRef as ReactComponent };